"use client";
import React from "react";
import { ArrowLeft } from "lucide-react";

interface PageHeaderProps {
  onBack: () => void;
  title: string;
  subtitle: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  onBack,
  title,
  subtitle,
}) => {
  return (
    <div className="flex items-center space-x-4 mb-8 animate-fadeInUp">
      <button
        onClick={onBack}
        className="flex items-center space-x-2 text-muted-foreground hover:text-foreground transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        <span>Back</span>
      </button>
      <div className="w-px h-6 bg-border"></div>
      <div>
        <h1 className="text-3xl font-bold text-foreground">{title}</h1>
        <p className="text-muted-foreground">{subtitle}</p>
      </div>
    </div>
  );
};
